import { useState, useEffect, useRef, Fragment, memo, useMemo, useCallback } from "react";
import style from "./../index.module.scss";
import styleUi from "./EditSchedule.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import * as YStyled from "../../Styleds";
import { countLinks } from "../../comm/comm";
const EditSchedule = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    const [schedule, set_schedule] = useState([]);
    useEffect(() => {
        console.log("arg.scheduleVo", arg.scheduleVo)
        set_schedule(arg.scheduleVo.length === 0 ? [{
            "time": "",
            "description": ""
        }] : arg.scheduleVo);
        setInProp(true);
    }, [])
    const handletTableDataChange = useCallback((setFn, key, index, value) => {
        setFn(prev => {
            const newTableData = [...prev];
            newTableData[index][key] = value;
            return newTableData;
        });
    }, [schedule]);
    const addRow = (setFn) => {
        setFn(prev => {
            if (prev.length > 0) {
                const newRow = Object.fromEntries(Object.keys(prev[0]).map(key => [key, ""]));
                return [...prev, newRow];
            }
            return prev;
        });
    };

    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "EditSchedule"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app}>
                                <div className={styleUi.header}>
                                    <img src="./assets/ui/back.png" onClick={e => {
                                        setInProp(false)
                                    }} />
                                </div>
                                <YStyled.Row style={{ marginBottom: "1rem", padding: "1rem 1rem .4rem 1rem" }}>
                                    <YStyled.Span size={17} >行程表</YStyled.Span>
                                    <YStyled.Span size={13} fontFamily="SF Pro" fontWeight={400} style={{ cursor: "pointer" }} onClick={e => {
                                        console.log("schedule", schedule)
                                        arg.editedCb(schedule);
                                        setInProp(false);
                                    }}>儲存</YStyled.Span>
                                </YStyled.Row>
                                <span>{`第${arg.day.toZH()}天 ・ ${arg.date}`}</span>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td><YStyled.Span size={17}  >時間</YStyled.Span></td>
                                            <td><YStyled.Span size={17}  >行程</YStyled.Span></td>
                                        </tr>
                                        {schedule.map((v, k) => (
                                            <tr key={k}>
                                                <td onClick={e => {
                                                    addModalType({
                                                        cls: "OptionSelector", arg: {
                                                            type: "time", onSelect: value => {
                                                                handletTableDataChange(set_schedule, "time", k, `${value.hr}:${value.min}`)
                                                            }
                                                        }
                                                    })
                                                }}>
                                                    <YStyled.Span size={17} fontWeight={400}>{v.time ?? "--:--"}</YStyled.Span>
                                                </td>
                                                <td>
                                                    {/* <CustomTextarea defaultValue={v.description} /> */}
                                                    <textarea maxLength={50} value={v.description} defaultValue={v.description} onChange={event => {
                                                        const linkCount = countLinks(event.target.value);
                                                        console.log("linkCount", linkCount)
                                                        if (linkCount >= 2)
                                                            alert("不得輸入超過2個連結")
                                                        else
                                                            handletTableDataChange(set_schedule, "description", k, event.target.value)
                                                    }}
                                                    >
                                                    </textarea>
                                                    {/* <YStyled.Input size={17} placeholder="輸入內容" defaultValue={v.description}
                                                        onBlur={(event) => handletTableDataChange(set_schedule, "description", k, event.target.value)}></YStyled.Input> */}
                                                </td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td colSpan="2">
                                                <div onClick={e => { addRow(set_schedule) }}>
                                                    <img src="./assets/ui/add.png" alt="新增" /><span><YStyled.Span size={15} >新增</YStyled.Span></span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(EditSchedule);